// @flow
import React, { useState, useCallback } from 'react';

import { goBack } from '../../lib/helpers';
import { sparePartsApi } from '../../lib/api';
import { type SpareParts } from '../../lib/types';

import CommonCardPage from '../../components/hoc/common/handbook/CardPage';
import { InnerForm } from './components';
import { getBreadCrumbsByUrlForEdit } from '../../lib/autoBreadcrumbs';

type PageProps = {
  id: number
};

const entryPointPath = '/admin/spare-parts/';

export default (props: PageProps) => {
  const [data: SpareParts, setData] = useState({
    id: props.id
  });

  const breadCrumbs = getBreadCrumbsByUrlForEdit(entryPointPath, props.id);

  const onFetch = useCallback(async () => {
    !!props.id && setData(await sparePartsApi.get(props.id));
  }, [props.id]);

  const onSubmit = async (payload: SpareParts) => {
    let id = payload.id;
    if (id) {
      await sparePartsApi.update(payload);
    } else {
      let data = await sparePartsApi.add(payload);
      id = data.id;
    }
    await goBack(`${entryPointPath}${id}`);
  };

  const onCancel = async (payload: SpareParts) => {
    if (data.id) {
      await goBack(`${entryPointPath}${data.id}`);
    } else await goBack(`${entryPointPath}`);
  };

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs,
        mainHeader: 'Запасные части'
      }}
      onFetch={onFetch}
      onSubmit={onSubmit}
      onCancel={onCancel}
    >
      <InnerForm data={data} useFooter noWrapMe />
    </CommonCardPage>
  );
};
